import { CardMedia, styled } from "@mui/material";


export const VideoContainer = styled('div')(({ theme }) => ({

    position: 'relative',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
        // Adjustments for medium screens
    },
    [theme.breakpoints.down('sm')]: {
        // Adjustments for small screens
        width: '100%',
        height: '100%',

        },
        marginTop: '40px',
        marginBottom:'20px'
}))



type StyledCardMediaProps = React.ComponentProps<typeof CardMedia> & {
    component?: string;
    alt?: string
}


export const StyledCardMedia = styled(CardMedia)<StyledCardMediaProps>(({ theme }) => ({
    maxWidth: '98%', // Full width of the parent container
    height: '90vh', // Height is auto to maintain aspect ratio
    objectFit: 'cover', // Cover the whole area without stretching
    borderRadius: '20px',
    marginBottom: '95px',


    [theme.breakpoints.down('sm')]: {
      height: '60vh',
      borderRadius: '20px',
      width: '100%', // Ensuring full width on small screens
    },
}));

export const StyledVideo = styled('video')(({ theme }) => ({
    width: '99%', // Full width of the parent container
    height: '90vh', // Height to maintain aspect ratio
    objectFit: 'cover', // Cover the whole area without stretching
    borderRadius: '20px',
    marginBottom: '95px',
    [theme.breakpoints.down('sm')]: {
        height: '60vh',
        borderRadius: '20px',
        width: '100%', // Ensuring full width on small screens
    },
}));


export const BaseVideo = styled(CardMedia)(({theme})=>({
    // position: 'absolute',
    zIndex: 1,
    width: '100%', // Full width of the parent container
    height: 'auto', // Keep aspect ratio
    top: 0,

  justifyContent: 'center',
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',

  }));